import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LaunchDarklyFlags } from '@models/feature-flag.enum';
import { FeatureFlagService } from '@services/feature-flag.service';
import { map } from 'rxjs';

export const featureFlagGuard = (flag: LaunchDarklyFlags): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const featureFlagService = inject(FeatureFlagService);

    return featureFlagService.getFlag(flag).pipe(
      map((flagState) => {
        return flagState || router.createUrlTree(['/']);
      }),
    );
  };
};
